module.exports = __webpack_public_path__ + "assets/img/ground.png?9b7a3ea3d93f211e6978ba7abf057a31";